module.exports = __webpack_public_path__ + "img/inventario.9b087eac.svg";